import React, { Fragment, useContext } from 'react';
import { Price, MoveToCarts } from '../../../Constant';
import { Btn, H6, Image } from '../../../AbstractElements';
import { useNavigate } from 'react-router';
import { Col,Row } from 'reactstrap';
import { Rating } from 'react-simple-star-rating';
import ProductContext from '../../../Context/Ecommerce/Product';
import CartContext from '../../../Context/Ecommerce/Cart';
import { Link } from 'react-router-dom';

const WishListData = () => {
  const Navigate = useNavigate();
  const { productItem, symbol } = useContext(ProductContext);
  const { addToCart } = useContext(CartContext);
  const MoveToCart = (product, qty) => {
    addToCart(product, qty);
    Navigate(`${process.env.PUBLIC_URL}/ecommerce/cart`);
  };

  return (
    <Fragment>
      <Row>
        {productItem.map((item) => {
          return (
            <Col xl='2' md='4' sm='6' key={item.id} className='box-col-3'>
              <div className='product-details-box'>
                <div className='d-flex'>
                  <Image className='align-self-center img-fluid' src={`${require(`../../../assets/images/${item.img}`)}`} alt='#' />
                  <div className='flex-grow-1'>
                    <div className='product-name'>
                      <Link href='3'>
                        <H6>{item.name}</H6>
                      </Link>
                    </div>
                    <div className='rating'>
                      <Rating initialValue={item.rating} size='17px' style={{ padding: '0' }} />
                    </div>
                    <div className='price'>
                      {Price}
                      <span>
                        : {item.price}
                        {symbol}
                      </span>
                    </div>
                    <div className='avaiabilty'>
                      <div className={`${item.stock === 'In stock' ? 'text-success' : 'text-danger'}`}>{item.stock}</div>
                    </div>
                    <Btn color='primary' size='xs' onClick={() => MoveToCart(item, 1)}>
                      {MoveToCarts}
                    </Btn>
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </Fragment>
  );
};
export default WishListData;
